import { ArrowRight, HeartHandshake, ShieldCheck, Sparkles, Users } from 'lucide-react';
import { Link } from 'react-router-dom';
import PageHero from '../components/PageHero';
import Seo from '../components/Seo';

export default function About() {
  return (
    <>
      <Seo title="About Us" description="Meet Jonny's Towing & Recovery, a Richmond towing company built around professional service, community involvement and genuine care." image="/images/flatbed-sunset.webp" />
      <PageHero
        eyebrow="Who we are"
        title="A towing company built to make difficult moments feel a little better."
        description="Professional equipment matters. So do communication, patience and the way people are treated when their day has gone wrong."
        image="/images/flatbed-sunset.webp"
      >
        <Link className="button button--primary" to="/services">View our services <ArrowRight size={18} /></Link>
      </PageHero>
      <section className="section container prose-grid">
        <article className="prose-copy">
          <span className="eyebrow">Driven by care</span>
          <h2>Reliable roadside help with a distinctly local personality.</h2>
          <p>Jonny’s Towing &amp; Recovery Ltd. serves Richmond and the Greater Vancouver area with towing, recovery and roadside assistance. We handle each call with the professionalism required to protect the vehicle and the empathy required to help the person.</p>
          <p>Our black trucks and bright-pink accents are easy to recognize, but our reputation is built on what happens after we arrive: clear communication, careful handling and the willingness to go beyond the expected.</p>
          <p>Community involvement is part of the company—not a marketing afterthought. We sponsor and support local initiatives, create school pumpkin-patch experiences, decorate our fleet for holidays and build original events that give families something memorable to enjoy.</p>
        </article>
        <aside className="image-panel">
          <img src="/images/rolls-royce-flatbed.webp" alt="Luxury vehicle safely transported by Jonny's Towing" />
          <div className="image-panel__caption">Careful handling for everyday vehicles, classics, luxury cars and specialty moves.</div>
        </aside>
      </section>
      <section className="section section--dark">
        <div className="container values-grid">
          {[
            [<ShieldCheck key="professionalism" />, 'Professionalism', 'The right equipment, safe methods and careful attention to the vehicle.'],
            [<HeartHandshake key="care" />, 'Human care', 'Calm communication and respect for people having a difficult day.'],
            [<Users key="community" />, 'Community', 'Projects, sponsorships and experiences that contribute beyond ordinary business.'],
            [<Sparkles key="personality" />, 'Personality', 'Creative details and unexpected kindness that make the service memorable.'],
          ].map(([icon, title, text]) => (
            <article className="value-card" key={title}>
              {icon}
              <h3>{title}</h3>
              <p>{text}</p>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
